import { render, staticRenderFns } from "./cascader-items.vue?vue&type=template&id=5859ddee&scoped=true&"
import script from "./cascader-items.vue?vue&type=script&lang=js&"
export * from "./cascader-items.vue?vue&type=script&lang=js&"
import style0 from "./cascader-items.vue?vue&type=style&index=0&id=5859ddee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5859ddee",
  null
  
)

component.options.__file = "cascader-items.vue"
export default component.exports